/**
 * Booking API
 *
 * Contact: support@xenoncloud.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type AddonItemHidden = 'HIDDEN_NEW' | 'HIDDEN_OLD';

export const AddonItemHidden = {
  HIDDEN_NEW: 'HIDDEN_NEW' as AddonItemHidden,
  HIDDEN_OLD: 'HIDDEN_OLD' as AddonItemHidden
};
